import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import LegalLayout from './LegalLayout';

export default function Confidentialite() {
  const { t } = useI18n();
  const p = t.legal.privacy;
  return (
    <LegalLayout eyebrow={p.eyebrow} title={p.title}>
      <p>{p.intro}</p>
      <h2>{p.h1}</h2>
      <ul>
        <li>{p.i1}</li>
        <li>{p.i2}</li>
        <li>{p.i3}</li>
      </ul>
      <h2>{p.h2}</h2>
      <p>{p.p2}</p>
      <h2>{p.h3}</h2>
      <p>{p.p3}</p>
      <h2>{p.h4}</h2>
      <p>{p.p4a} <Link to="/support">{p.p4link}</Link>{p.p4b}</p>
      <h2>{p.h5}</h2>
      <p>{p.p5}</p>
    </LegalLayout>
  );
}
